import React from 'react';
import './Agenda.css';
import VideoPresent from './VideoPresent/VideoPresent';
import Gosebrink from '../../img/agenda/Gosebrink.png'
import Haibrid from '../../img/agenda/Haibrid.png'
import ITH from '../../img/agenda/ITH.png'
import Microsoft from '../../img/agenda/Microsoft.png'
import OSS from '../../img/agenda/OSS.png'
import Rank from '../../img/agenda/Rank.png'
import Salnikov from '../../img/agenda/Salnikov.png'
import Yusuf from '../../img/agenda/Yusuf.png'

export default class Agenda extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            list: [
              {
                  id: 1,
                  time: '09:10',
                  photo: Gosebrink,
                  name: 'Fabian Gosebrink',
                  position: 'Technical Lead',
                  tw: 'https://twitter.com/fabiangosebrink',
                  logo: OSS,
                  title: 'Angular Architectures with NgRx Stores & Effects',
                  abstract: `Angular offers you nearly endless possibilities in frontend, but with great power comes great responsibility. If an application grows, we sooner or later have to face the question of state management on client side. But what is a state exactly? And what does "stateful" and "stateless" mean? And how can I manage the state of my application in a nice and clean way? Tools like NgRx with stores and effects can help us to design our application in a very lightweight and beautiful way. In this talk, Fabian Gosebrink will shed a light on how to use NgRx with stores and separate effects so that we do not have to fear big angular architectures again.`,
              },
              {
                  id: 2,
                  time: '09:40',
                  photo: Salnikov,
                  name: 'Maxim Salnikov',
                  position: 'Developer Engagement Lead',
                  ln: 'https://www.linkedin.com/in/webmax/',
                  tw: 'https://twitter.com/webmaxru',
                  logo: Microsoft,
                  title: 'Sending the Angular app into deep, deep offline with Workbox',
                  abstract: `There is no need to advocate for progressive web apps anymore. The idea of connection-independent applications has proven its viability and we see more and more large and small projects following that path, making the offline-ready behavior a best practice, good manner of the web. In my session, based on the deep exploration of Service Worker API possibilities and gathered UX gotchas, we go through the history of the offline web, the importance of treating the network as an enhancement, current challenges (and their solutions) and proper tooling. We architect our offline-ready Angular app applying the best tech and UX practices adding the features one-by-one: app shell, caching resources and data, sync when online. All in name of our users who demand the new level of the resilient web experience.`,
              },
              {
                  id: 3,
                  time: '10:10',
                  photo: Yusuf,
                  name: 'Sani Yusuf',
                  position: 'Founder',
                  ln: 'https://www.linkedin.com/in/saniyusuf',
                  tw: 'https://twitter.com/saniyusuf',
                  logo: Haibrid,
                  title: 'Differential Loading',
                  abstract: `Creating applications that serve users from near and far can be challenging. There are endless things you have to try to normalise across the board. To mention a few you have to watch out for Browser support, accessibly to name a few. It is impossible to make a perfect application but sometimes, especially when we want to use modern JS features.

                  Polyfills are great but sometimes, they do add extra payload for the users that do not need the polyfills in the first place. Angular's built-in Differential loading helps us achieve an automated way of ensuring that users only get a build that includes only the tools they need and nothing more.`,
              },
              {
                  id: 4,
                  time: '10:40',
                  photo: Rank,
                  name: 'Jay Rank',
                  position: 'Full Stack Blockchain Developer',
                  ln: 'https://www.linkedin.com/in/rankjay/',
                  tw: 'https://twitter.com/RankJay1',
                  github: 'https://github.com/RankJay',
                  logo: ITH,
                  title: 'Applications of Angular in Web 3.0',
                  abstract: `Angular JS for Web3, Applications of Web3, Frameworks to use for Web3, Building a simple DApp using Angular`,
              },
          ],
        }
      }

    render() {
        return (
            <div className="agenda" id='agenda'>
                <div className='container agenda'>
                    <h3 className="agenda_title">Agenda</h3>
                    <p className="agenda_undertitle">Time zone 0 UTC</p>
                    <p className="agenda_undertitle">March 29 09:00 - 18:00</p>
                    <p className="agenda_day">Junior Day</p>
                    <VideoPresent speakers={this.state.list}/>
                    <a className='full_agenda_btn' href='https://geekle.us/schedule/angular22' target='_blank' rel="noreferrer">SHOW FULL AGENDA</a>
                </div>
            </div>
        );
    }
};